import React from 'react';
export type POS = 'top' | 'bottom';
export interface Props {
  pos?: POS;
}

/**
 * CUSTOM RIGHT HAND SIDE HEADER PANEL
 * * pos: top | bottom
 */
export const LoadMoreComponent: React.FC<Props> = (props: any) => {
  const { pos } = props;
  return props.children ? (
    <div className="load-more--wrapper">
      {pos && <div className={`load-more--dropShadow-${pos}`}></div>}
      {props.children}
    </div>
  ) : null;
};

export default LoadMoreComponent;
